import {takeEvery} from 'redux-saga/effects'

import {
  ADD_GALLERY_PHOTO,
  CREATE_EVENT,
  DELETE_EVENT,
  DELETE_GALLERY_PHOTO,
  DELETE_MANY_EVENTS,
  GET_EVENT,
  GET_EVENTS,
  GET_EVENT_GALLERY,
  SEND_EVENT_NOTIFICATION,
  UPDATE_EVENT,
  UPDATE_EVENT_PERMISSIONS,
} from '../../../Actions/Event/ActionTypes/ApiActionTypes'
import fetchData from '../../SagaHelper'

function* eventSaga() {
  yield takeEvery(GET_EVENT, fetchData)
  yield takeEvery(GET_EVENTS, fetchData)
  yield takeEvery(CREATE_EVENT, fetchData)
  yield takeEvery(UPDATE_EVENT, fetchData)
  yield takeEvery(DELETE_EVENT, fetchData)
  yield takeEvery(DELETE_MANY_EVENTS, fetchData)
  yield takeEvery(GET_EVENT_GALLERY, fetchData)
  yield takeEvery(ADD_GALLERY_PHOTO, fetchData)
  yield takeEvery(DELETE_GALLERY_PHOTO, fetchData)
  yield takeEvery(UPDATE_EVENT_PERMISSIONS, fetchData)
  yield takeEvery(SEND_EVENT_NOTIFICATION, fetchData)
}
export default eventSaga
